import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store, { persistor } from "./Redux/store";
import axios from "axios";
import { BASE_URL } from "./Constants/common";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./config/queryClient";

axios.defaults.baseURL = BASE_URL;
axios.defaults.timeout = 45000;

axios.interceptors.response.use(undefined, (error) => {
  const { response } = error;

  if (response && response.status === 503) {
    window.alert("helo no internet.");
    return Promise.reject(error);
  }

  if (
    (response &&
      response.status === 401 &&
      localStorage.getItem("accessToken")) ||
    !localStorage.getItem("accessToken")
  ) {
    window.location.replace("/login");
  }

  return Promise.reject(error);
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor} />
        <App />
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
